import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";

const BG = "https://images.unsplash.com/photo-1584897356466-858d9b6c53d1?auto=format&fit=crop&w=1600&h=900&q=80";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const token = sp.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-ink/85" />
      <div className="relative z-10 w-full max-w-md bg-surface/90 backdrop-blur-xl border border-white/10 rounded-2xl p-8 animate-fade-up">
        <Logo size="lg" className="mb-6" />
        <h1 className="font-display text-3xl font-black mb-6">New Password</h1>
        {!token ? (
          <p className="text-white/70 text-sm">Invalid reset link. <Link to="/forgot-password" className="text-gold">Request a new one</Link>.</p>
        ) : done ? (
          <p data-testid="reset-success" className="text-gold">Password updated! Redirecting to sign in...</p>
        ) : (
          <>
            {error && <p className="bg-brand/15 text-brand text-sm rounded-md px-3 py-2 mb-4">{error}</p>}
            <form onSubmit={submit} className="space-y-4">
              <input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" className="w-full bg-ink border border-white/10 rounded-md px-4 py-3 outline-none focus:ring-1 focus:ring-brand" />
              <button data-testid="reset-submit" disabled={loading} className="w-full bg-brand hover:bg-brand/90 rounded-md font-semibold py-3 flex items-center justify-center gap-2 disabled:opacity-60">
                {loading && <Loader2 className="w-4 h-4 animate-spin" />} Reset Password
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
